import { render, staticRenderFns } from "./club_info_form.vue?vue&type=template&id=c0512f72&"
import script from "./club_info_form.vue?vue&type=script&lang=js&"
export * from "./club_info_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports